import Banner from "./Bannner";
import ContactFooter from "./ContactFooter";
import NewsContainers from "./NewsContainers";

import glv from "../utils/getLocalizedValue";

function NewsPage() {
  return (
    <>
      <div
        className="w-full flex-grow overflow-y-scroll overflow-x-hidden"
        style={{ scrollSnapType: "y proximity" }}
      >
        <Banner
          title={glv("News and Updates","최신 뉴스")}
          src={require("../assets/banner/news-banner.jpg")}
        />
        <div className="max-w-[70rem] font-pretendard f-20 font-[300] mt-[7rem] mb-[3rem] sm:px-0 px-5 text-justify ms-auto me-auto">
          {glv(
            <span>
              Here we bring you the forefront of semiconductor and thermal
              management advancements, industry events, and company milestones.
              Discover how we’re shaping the future of technology and delivering
              solutions that power the next generation of consumer electronics.
              <br />
              <br />
              To stay up to date with the latest innovations, achievements, and
              insights from KoolMicro, consider subscribing to our Newsletter
              service through the form down below!
            </span>,
            <span>
              KoolMicro의 최신 반도체 및 열 관리 기술의 발전, 업계 행사, 그리고
              주요 성과를 소개합니다.<br/> 저희가 어떻게 기술의 미래를 선도하고
              있으며 차세대 전자제품에 최적화된 솔루션을 만들고 있는지 확인해
              보세요.<br/><br/> KoolMicro의 혁신, 성과, 그리고 최신 동향을 빠르게 받고
              싶다면, 페이지 아래 양식을 통해 뉴스레터 서비스를 구독해 보세요.
            </span>
          )}
        </div>
        <main className="flex flex-col items-center justify-center pb-[10rem] first:pt-0 last:pb-0">
          <NewsContainers />
        </main>
        <ContactFooter />
      </div>
    </>
  );
}

export default NewsPage;
